import {FC, useState} from 'react'
import clsx from 'clsx'
import {Link, useLocation} from 'react-router-dom'
import {checkIsActive, WithChildren} from '../../../helpers'
import {useLayout} from '../../core/_LayoutProvider'
import {getEncryptedRoute, useMenuIdPermissions} from '../../../../reusable'

type Props = {
  to: string
  title: string
  icon?: string
  supportCount?: number
  reviewCount?: number
  fontIcon?: string
  menuId?: any
  hasBullet?: boolean
  hasMain?: string
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  supportCount,
  reviewCount,
  title,
  icon: IconComponent,
  fontIcon,
  menuId,
  hasBullet = false,
  hasMain = '',
}) => {
  // const pathname = sessionStorage.getItem('currentMenu')
  const {pathname} = useLocation()

  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config
  const [menu, setMenu] = useState('')
  const {urlData} = useMenuIdPermissions()

  return (
    <div className='menu-item'>
      <Link
        className={clsx(`menu-link without-sub ${title == menu ? 'text-dark' : 'text-white'}`, {
          active: !urlData.menuId && menuId == 1 ? true : urlData.menuId == menuId,
        })}
        to={getEncryptedRoute(to.trim(), {menuId: menuId})}
        
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {IconComponent && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <IconComponent />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span
          className='menu-title'
          onClick={() => {
            setMenu(title)
          }}
        >
          {title}
          {(supportCount && supportCount > 0) || (reviewCount && reviewCount > 0) ? (
            <sup>
              <div
                className='spinner-grow spinner-grow-lg text-danger w-10px h-10px ms-1 mt-3'
                role='status'
              ></div>
            </sup>
          ) : (
            ''
          )}
        </span>
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
